import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchFeatures = createAction(ACTION.FETCH_FEATURES.REQUEST, (filter = {}) => ({filter}));
